import { apiClient } from '@/infrastructure/api'
import {
  AIInsightsApi,
  AIInsightsApiGetAIInsightsRequest
} from '@itsrever/rever-api'

export const aiInsightsApi = new AIInsightsApi(undefined, undefined, apiClient)

async function getReturnRateInsights(args: AIInsightsApiGetAIInsightsRequest) {
  const result = await aiInsightsApi.getAIInsights(args)

  return result
}

export default {
  getReturnRateInsights
}
